import { render } from "./HowToPrayTheRosary.vue?vue&type=template&id=506d8c9f&scoped=true"
const script = {}

import "./HowToPrayTheRosary.vue?vue&type=style&index=0&id=506d8c9f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506d8c9f"]])

export default __exports__